"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.Autofill = void 0;
var _autofill = require("./autofill");
exports.PLUGIN_KEY = _autofill.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _autofill.PLUGIN_PRIORITY;
exports.Autofill = _autofill.Autofill;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/autofill/index.js
// module id = 1237
// module chunks = 0